import { render, staticRenderFns } from "./FreshRelevanceTrackingTag.vue?vue&type=template&id=648245b3&"
import script from "./FreshRelevanceTrackingTag.vue?vue&type=script&lang=js&"
export * from "./FreshRelevanceTrackingTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports